import { SiteNavigation } from '@/lib/types'

export function isInSiteLink(type: SiteNavigation['type']) {
  return ['notion-page', 'home'].includes(type)
}
